module.exports = __webpack_public_path__ + "img/logo11.a79d5465.png";